import ServicePageTemplate from "@/components/layout/ServicePageTemplate";

export default function DrywallPage() {
  return (
    <div data-testid="drywall-page">
      <ServicePageTemplate
        overline="Drywall & Patch"
        title="Smooth professional finishes that disappear into your space."
        sub="Whether the damage was caused by plumbing access, remodeling, water damage or general wear, our team delivers finishes that blend naturally."
        image="https://images.pexels.com/photos/3637786/pexels-photo-3637786.jpeg"
        serviceTitle="Drywall"
        services={[
          "Drywall Repair",
          "Drywall Installation",
          "Plumbing Access Patching",
          "Ceiling Repairs",
          "Texture Matching",
          "Water Damage Repairs",
          "Hole & Crack Repairs",
          "Interior Wall Restoration",
          "Painting & Finishing",
          "Remodel Patch Work",
        ]}
        benefits={[
          "Clean Professional Finish",
          "Fast Turnaround",
          "Texture Matching Available",
          "Reliable Scheduling",
          "Quality Materials",
          "Residential & Commercial",
        ]}
        faq={[
          { q: "Can you match existing wall texture?", a: "Yes — knockdown, orange peel, smooth and custom textures are all in our wheelhouse." },
          { q: "Do you handle paint after the patch?", a: "We handle full prep, prime and paint so the repair fully disappears." },
          { q: "Can you fix water damage?", a: "Yes — we remove damaged drywall, address moisture, and rebuild with new material and a finished texture." },
        ]}
      />
    </div>
  );
}
